/**
 * Normaliza un email para validación, envío y almacenamiento:
 * recorta espacios al inicio/final y fuerza minúsculas.
 * NO altera espacios internos (esos los rechaza la validación).
 *
 * Se escribe en CommonJS (como utils/normalizeForKey.js) para que sea
 * consumible tanto por el bundle vía `import` (interop de webpack/Next)
 * como por los tests de Jest vía `require`.
 */
const normalizeEmail = (email = '') =>
  typeof email === 'string' ? email.trim().toLowerCase() : '';

module.exports = { normalizeEmail };
